import PersonasAvatar from './personas-avatar';

export { PersonasAvatar };
